import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()

const state = {
  managementModelData: {},
  managementModelMark: 0,
  /**
   * 入库配置
   */
  intoConfigSelect: [],
  intoConfigList: [],
  intoConfigMark: 0,
  /**
   * 出库配置
   */
  outConfigList: [],
  outConfigMark: 0
}

const actions = {
/* *仓内管理模式配置 S */
  [types.GETHECKED] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/openConfig/configOpenType', params).then(data => {
        context.commit(types.GETHECKED, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  [types.PRODUCTIONOPEN] (context, params) {
    http.fetch('/api/openConfig/productionOpen', params).then(data => {
      context.commit(types.PRODUCTIONOPEN, data)
    })
  },
  /* *仓内管理模式配置 E */

  /* *账单核对策略 S */
  [types.CONFIGBILLCHECKDAYS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/warehouse/configBillCheckDays', params).then(data => {
        context.commit(types.CONFIGBILLCHECKDAYS, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取仓库账单核对时间
  [types.GETBILLCHECKDAYS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/warehouse/getBillCheckDays', params).then(data => {
        context.commit(types.GETBILLCHECKDAYS, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /* *账单核对策略 E */

  /**
   * 入库配置
   */
  // 获取下拉框
  [types.SELECTAREALIST] (context, params) {
    http.fetch('/api/area/selectAreaList', params).then(data => {
      context.commit(types.SELECTAREALIST, data)
    })
  },
  // 获取列表
  [types.GETPUTCONFIG] (context, params) {
    http.fetch('/api/putConfig/getPutConfig', params).then(data => {
      context.commit(types.GETPUTCONFIG, data)
    })
  },
  // 编辑
  [types.SETPUTCONFIG] (context, params) {
    http.fetch('/api/putConfig/setPutConfig', params).then(data => {
      context.commit(types.SETPUTCONFIG, data)
    })
  },
  /**
   * 出库配置
   */
  // 获取列表
  [types.GETOUTCONFIG] (context, params) {
    http.fetch('/api/outConfig/getOutConfig', params).then(data => {
      context.commit(types.GETOUTCONFIG, data)
    })
  },
  // 编辑
  [types.SETOUTCONFIG] (context, params) {
    http.fetch('/api/outConfig/setOutConfig', params, 'application/json').then(data => {
      context.commit(types.SETOUTCONFIG, data)
    })
  }
}

const mutations = {
  /* *仓内管理模式配置 S */
  [types.GETHECKED] (state, data) {
  },
  [types.PRODUCTIONOPEN] (state, data) {
    if (data.code === 200) {
      state.managementModelMark = 1
      setTimeout(() => {
        location.reload()
      }, 1500)
    } else if (data.code === 500) {
      state.managementModelMark = 2
    }
  },
  /* *仓内管理模式配置 S */
  /* *账单核对策略 S */
  [types.CONFIGBILLCHECKDAYS] (state, data) {
  },
  [types.GETBILLCHECKDAYS] (state, data) {
  },
  /* *账单核对策略 E */
  /**
   * 入库配置
   */
  // 获取下拉框
  [types.SELECTAREALIST] (state, data) {
    state.intoConfigSelect = data.obj
  },
  // 获取列表
  [types.GETPUTCONFIG] (state, data) {
    state.intoConfigList = data.obj
  },
  // 编辑
  [types.SETPUTCONFIG] (state, data) {
    state.intoConfigMark = 1
    if (data.code !== 200) return false
    vue.$message({
      showClose: true,
      message: '编辑成功',
      type: 'success'
    })
  },
  /**
   * 出库配置
   */
  // 获取列表
  [types.GETOUTCONFIG] (state, data) {
    state.outConfigList = data.obj
  },
  // 编辑
  [types.SETOUTCONFIG] (state, data) {
    state.outConfigMark = 1
    if (data.code !== 200) return false
    vue.$message({
      showClose: true,
      message: '编辑成功',
      type: 'success'
    })
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/warehouseTactics/index.js